import { useEffect } from "react";

const SITE = "Aethel Decor";
const SITE_URL = "https://aetheldecor.com";
const DEFAULT_DESC =
  "Aethel Decor — Beyond Decor: Simply Elevated. Shop wooden trays, ceramic bowls, pure cotton bedsheets, cushion covers, table runners and more. Free shipping across India, Cash on Delivery available.";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo({ title, description, image, path } = {}) {
  useEffect(() => {
    const fullTitle = title
      ? `${title} | ${SITE}`
      : `${SITE} — Beyond Decor: Simply Elevated | Home Decor Online India`;
    const desc = (description || DEFAULT_DESC).slice(0, 300);
    const url = `${SITE_URL}${path || window.location.pathname}`;

    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", SITE);
    setMeta("property", "og:url", url);
    if (image) setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", desc);

    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
  }, [title, description, image, path]);
}
